import { render, staticRenderFns } from "./freightAmount.vue?vue&type=template&id=e30e4260&scoped=true&"
import script from "./freightAmount.vue?vue&type=script&lang=js&"
export * from "./freightAmount.vue?vue&type=script&lang=js&"
import style0 from "./freightAmount.vue?vue&type=style&index=0&id=e30e4260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30e4260",
  null
  
)

export default component.exports